
export default function Hero() {
  const scrollToQuote = () => {
    const element = document.getElementById('quote-form');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/054657f6f620d41d02c4a3b2e6552990.jpg')`
        }}
      ></div>
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
        <h2 className="text-5xl lg:text-7xl font-bold text-white mb-6 font-['Poppins'] leading-tight">
          Professional Commercial<br />
          <span className="text-teal-400">Cleaning Services</span>
        </h2>
        
        <p className="text-xl lg:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          Comprehensive cleaning solutions encompassing general maintenance, window care, and specialized floor treatments. Our quality assurance protocols guarantee service delivery aligned with contractual scope requirements.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <button
            onClick={scrollToQuote}
            className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Free Quote
          </button>
          <button
            onClick={scrollToServices}
            className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Our Services
          </button>
        </div>

        {/* Features */}
        <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
              <i className="ri-shield-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Quality Assurance</h3>
            <p className="text-white/80 text-sm">Service delivery aligned with scope requirements</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
              <i className="ri-leaf-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">Eco-Friendly</h3>
            <p className="text-white/80 text-sm">Safe, green cleaning products</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
